import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiResponse } from '@/shared/types';
import { processesRepo } from '@/constants/providers';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ProcessKey } from './keys';
import { BusinessAreasKey } from '@/modules/BusinessAreas/queries/keys';
import { CompanyKeys } from '@/modules/Companies/queries';
import { OrganizationKeys } from '@/modules/Organizations/queries/keys';

export const useDeleteProcess = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<unknown>, unknown, number>(
    (id: number) => processesRepo.deleteProcess(id),
    {
      onError: () => {
        toast.error(t('error_deleting_process'));
      },
      onSuccess: () => {
        toast.success(t('success_deleting_process'));

        queryClient.invalidateQueries(ProcessKey.ALL);
        queryClient.invalidateQueries(BusinessAreasKey.ALL);
        queryClient.invalidateQueries(CompanyKeys.ALL);
        queryClient.invalidateQueries(OrganizationKeys.ALL);
      },
    },
  );
};
